module.exports = __webpack_public_path__ + "media/img/covers/profile-cover-2-9a9a26fd8ad119841e505903ce7835ad.jpg";